import { BASE_HEADERS } from '@/lib/api/config';

import { leiaApiPayload } from '@/utils/leiaClientSide';
import { formatFlags } from '@/utils/sessionFlags';

import { StartPlayGeniusCheckoutPayload } from '../usePlayGeniusCheckout';

export type startPlayGeniusCheckoutProps = {
  payload: StartPlayGeniusCheckoutPayload;
  source: string;
  flags: Record<string, any>;
  userJwt?: string;
  fbclid?: string;
};

export interface TypeStartCheckoutResponse {
  uuid: string;
}

export async function startPlayGeniusCheckout({
  payload,
  source,
  flags,
  userJwt,
  fbclid,
}: startPlayGeniusCheckoutProps): Promise<TypeStartCheckoutResponse> {
  const url = `/api/v1/checkout_orchestration/start_checkout?source=${source}&fbc=${fbclid ?? ''}`;

  try {
    const options = {
      method: 'POST',
      body: JSON.stringify({
        ...leiaApiPayload(),
        ...payload,
        le_flags: formatFlags(flags),
      }),
      headers: {
        ...BASE_HEADERS,
        ...(userJwt && { Authorization: userJwt }),
        'X-User-Agent': navigator.userAgent,
      },
    };

    const response = await fetch(url, options);

    if (!response.ok) {
      let errorMessage = `[startPlayGeniusCheckout] failed with status ${response.status}`;

      try {
        const errorData = await response.json();

        errorMessage += `: ${errorData.message || JSON.stringify(errorData)}`;
      } catch {
        // fallback to status text if data is not JSON
        errorMessage += ` - ${response.statusText}`;
      }

      throw new Error(errorMessage);
    }

    return await response.json();
  } catch (error) {
    console.error('Error in startPlayGeniusCheckout:', error);

    throw error instanceof Error
      ? new Error(`Failed to start checkout: ${error.message}`)
      : new Error('Failed to start checkout: An unknown error occurred');
  }
}
